import {Component, Input} from '@angular/core';

@Component({
    selector: 'pickup-day',
    providers: [],
    templateUrl: 'pickup-day.component.html'
})
export class PickupDayComponent{
    @Input()
    puDay: any;
    @Input()
    isToday:boolean;
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/home/pickup-week/pickup-day/pickup-day.component.ts